/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { getAnalyticsWebClientPromise } from '@jira/platform__observability-product-analytics-web-client-async';
import type { BifrostRouteGroup } from '@jira/platform__routing-route-types/src/JiraSpaRoute.tsx';
import type {
	Match,
	Route,
	MatchedRoute,
	HistoryAction,
	JiraSpaRoute,
	Location,
	Query,
	Routes,
} from '@atlassian/react-resource-router/src/common/types.tsx';
import type { RouterState } from '@atlassian/react-resource-router/src/controllers/router-store/types.tsx';

let matchedRoute: MatchedRoute | null = null;

export const setMatchedRoute = (route?: Route | null, match?: Match): void => {
	if (route && match) {
		matchedRoute = { route, match };
	}
};

export const getMatchedRoute = (): MatchedRoute | null => matchedRoute;

export const getRouteName = (): string => matchedRoute?.route.name ?? 'unknown';

export const getUserLocation = (): string =>
	`${matchedRoute?.route.group ?? 'unknown'}:${getRouteName()}`;

export const getUfoName = (): string | undefined => {
	return matchedRoute?.route?.ufoName ?? 'unknown';
};

export const getBifrostGroup = (): BifrostRouteGroup | 'none' | undefined => {
	return matchedRoute?.route?.bifrost?.bifrostGroup ?? 'none';
};

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports, jira/export/restrict-types-re-export
export type { RouterState };

let previousRouterState: RouterState | null = null;
let previousSubProduct = '';

export const setPreviousRouterState = (state: RouterState | null): void => {
	previousRouterState = state;
};

export const getPreviousRouterState = (): {
	action: HistoryAction;
	basePath: string;
	location: Location;
	match: Match;
	query: Query;
	route: JiraSpaRoute;
	routes: Routes;
	isLazyRoutes: boolean;
} | null => previousRouterState;

export const setPreviousSubProduct = (subProduct: string | null): void => {
	previousSubProduct = subProduct || '';
};

export const getPreviousSubProduct = (): string => previousSubProduct;

export const setSubProduct = (subproduct: string | null): void => {
	if (subproduct === null) {
		return;
	}

	if (previousSubProduct !== subproduct) {
		setPreviousSubProduct(subproduct);
	}

	getAnalyticsWebClientPromise().then((client) => {
		client.setSubProduct(subproduct);
	});
};
